{
    "BANNER": {
        "TITLE": " Nationwide Access to Premium Healthcare",
        "DESCRIPTION": "Pay direct for routine care at the time of service, and less than what you would with insurance because of copays, deductibles, and coinsurances. Our packages are perfect as standalone protection, or as supplements to insurance plans.",
        "BTNTEXT": "View Plans"
    },
    "FEATURE": {
        "TITLE": "Featured in"
    },
    "BENEFITS": {
        "MINI_TITLE": "Benefits you get",
        "TITLE": "Take control of your healthcare",
        "BOX1": {
            "TITLE": "Nationwide Availability",
            "DESCRIPTION": "1M+ community of direct-pay providers across the complete continuum of care"
        },
        "BOX2": {
            "TITLE": "Member Focused Care",
            "DESCRIPTION": "Intuitive workflows with complete price transparency, and 24/7 customer support"
        },
        "BOX3": {
            "TITLE": "Freedom from Contracts",
            "DESCRIPTION": "Monthly plans without commitments, and no “pre-authorizations” to get the care you need!"
        }
    },
    "DISCOUNT": {
        "MINI_TITLE": "Benefits you get",
        "TITLE": "Up to 80% discount on your healthcare needs!",
        "SERVICE1": {
            "TITLE": "Virtual Urgent Care",
            "SUBHEAD1": "Unlimited encounters",
            "SUBHEAD2": "24/7 Availability"
        },
        "SERVICE2": {
            "TITLE": "Mental Health Counseling",
            "SUBHEAD1": "Unlimited Use",
            "SUBHEAD2": "Certified Mental Health Experts"
        },
        "SERVICE3": {
            "TITLE": "Medications",
            "SUBHEAD1": "95% top meds at Zero cost",
            "SUBHEAD2": "70k+ Pharmacies"
        },
        "SERVICE4": {
            "TITLE": "Office Visit",
            "SUBHEAD1": "Up to 35%+ discount",
            "SUBHEAD2": "350k+ Doctors"
        },
        "SERVICE5": {
            "TITLE": "Dental",
            "SUBHEAD1": "Over 60% discount",
            "SUBHEAD2": "265K+ Dentists"
        },
        "SERVICE6": {
            "TITLE": "Vision",
            "SUBHEAD1": "Up to 75% discount",
            "SUBHEAD2": "100k+ Eye Clinics"
        },
        "SERVICE7": {
            "TITLE": "Lab Tests",
            "SUBHEAD1": "Up to 60%+ discount",
            "SUBHEAD2": "2100+ Labs"
        },
        "SERVICE8": {
            "TITLE": "Imaging",
            "SUBHEAD1": "Up to 75% discount",
            "SUBHEAD2": "1200+ Imaging Centers"
        },
        "SERVICE9": {
            "TITLE": "Procedures",
            "SUBHEAD1": "Over 50% discount",
            "SUBHEAD2": "5k+ Surgery Centers"
        },
        "SERVICE10": {
            "TITLE": "Hospitalization & ER visits",
            "SUBHEAD1": "Over 60% savings on premiums",
            "SUBHEAD2": "Nationwide & Global Access"
        },
        "SERVICE11": {
            "TITLE": "Preventive Care",
            "SUBHEAD1": "One office visit, Mammogram, etc.",
            "SUBHEAD2": "Nationwide Availability"
        }
    },
    "MEMBERSHIP": {
        "MINI_TITLE": "Affordable Healthcare solution for you!",
        "TITLE": "Healthcare access with membership, no insurance needed",
        "DENTAL_VISION_LABEL": "Add Dental & Vision Benefits",
        "REDUCE_IN_PERSON_LABEL": " Reduce In-person Primary Care to $10 & Urgent Care to $25 ",
        "LABEL": "This plan includes:",
        "NOTE1": "**Comprehensive plan is not available to residents of WA",
        "NOTE2": "**HealthShare is not available in WA",
        "NOTE3": "**75% off for each additional family member",
        "MEMBERNOTES_LABEL": "Notes:",
        "MEMBERNOTES": " After 3 months, get one subsidized visit (50% reimbursement, up to $150). After 6 months, get a second subsidized visit. Can roll over 1 unused visit to the next year. ",
        "BTN_LABEL": "Get Started Now"
    },
    "DISCOUNT50": {
        "TITLE": "HealthShare- Saves you 50% on large medical expenses and everyday care",
        "DESCRIPTION": "HealthSharing helps in managing large healthcare expenses, but still costs 50% less than typical health insurance. Members are part of a community that collects monthly membership fees. When a member has a large medical need like an ER visit, hospitalization, surgery, etc, it is paid by the HeathSharing community.",
        "MINI_TITLE": "Learn more"
    },
    "TESTIMONIAL": {
        "MINI_TITLE": "Testimonials",
        "TITLE": "See how we've helped our members by hearing their stories."
    },
    "HOWITWORKS": {
        "MINI_TITLE": "How it works",
        "TITLE": "As our member, here's how you can start using your benefits :",
        "STEP1": "Pick a plan to receive discounts with unlimited use.",
        "STEP2": "Make sure to complete your profile after payment to activate the plan.",
        "STEP3": "Connect with the medical provider you need.",
        "STEP4": "Pay the discounted direct-pay rate for your services.",
        "STEP5": "Get the care you need and focus on healing, not worrying about bills in the mail."
    },
    "FAQS": {
        "MINI_TITLE": "How it works",
        "TITLE1": "Frequently",
        "TITLE2": "Asked Questions",
        "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
        "LINK": "Visit Faqs Page",
        "FAQ_LIST": [
            {
                "title": "What Is Virtual Primary Care?",
                "description": "Virtual primary care provides online consultations with licensed healthcare providers for routine check-ups, chronic disease management, and general health concerns, all from the comfort of your home."
            },
            {
                "title": "Is My Information Secure During Virtual Consultations?",
                "description": "Yes, all virtual consultations are conducted on HIPAA-compliant platforms to ensure your data and privacy are fully protected."
            },
            {
                "title": "What Technology Do I Need for a Virtual Appointment?",
                "description": "You’ll need a smartphone, tablet, or computer with a stable internet connection and a camera for video consultations."
            },
            {
                "title": "How Do I Use the \"Message a Specialist\" Feature?",
                "description": "1. Log in to your WoW Health account. 2. Go to the \"Dashboard\" from the top bar. 3. Click on “See a Doctor” 4. Select the “Message a Specialist” option. 5. Click on “Access Portal.” 6. Fill out the required details about your symptoms and health concerns. 7. Submit your request. If you have any questions or require assistance, our customer support team is available 24/7 to help you."
            },
            {
                "title": "Can I Use This Service for Any Medical Concern?",
                "description": "Yes, you can use it for various non-emergency concerns, such as discussing symptoms, getting expert’s opinions, or understanding test results."
            },
            {
                "title": "Is There a Response Time Guarantee?",
                "description": "Most specialists respond within 24 hours, though response times may vary depending on the complexity of the queries."
            },
            {
                "title": "How Can I Book a Tele-Psychology Session?",
                "description": "To book a Tele-Psychology appointment with WoW Health: 1. Log in to your WoW Health account. 2. Go to the \"Mental Health & Wellness\" section. 3. Select \"Tele-Psychology.\" 4. Schedule an appointment by following the on-screen prompts."
            },
            {
                "title": "Can I Choose My Psychologist?",
                "description": "Absolutely! WoW Health allows you to browse profiles of available therapists and select one based on their expertise, credentials, and approach."
            },
            {
                "title": "What Conditions Can Be Treated with Tele-Psychiatry?",
                "description": "Tele-psychiatry on WoW Health can help with conditions like depression, anxiety, bipolar disorder, OCD, ADHD, PTSD, and other mental health issues that may require medication or psychiatric support."
            }
        ]
    }
}